var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCheckIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 22
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 10,
  height: 10,
  x: 4,
  y: 6,
  opacity: 0.2,
  rx: 1
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#checkIcon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.353 8.647a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.707 0l-2-2a.5.5 0 0 1 .707-.708L8 12.292l3.647-3.645a.5.5 0 0 1 .708 0h-.002Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "checkIcon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M5.5 7h7v8h-7z"
})))));
export default SvgCheckIcon;